import { Tabs, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faKey } from "@fortawesome/free-solid-svg-icons";
import ProfileTab from "./ProfileTab";
import TeamTab from "./TeamTab";
import ApiCredentialsTab from "./ApiCredentialsTab";
import styles from "./settings.module.scss";

const { Text } = Typography;

const SettingsPage: React.FC = () => {
  const tabs = [
    {
      key: "profile",
      label: <span><FontAwesomeIcon icon={faUser} className={styles.tabIcon} />Profile</span>,
      children: <ProfileTab />,
    },
    {
      key: "team",
      label: <span><FontAwesomeIcon icon={faUsers} className={styles.tabIcon} />Team</span>,
      children: <TeamTab />,
    },
    {
      key: "api-credentials",
      label: <span><FontAwesomeIcon icon={faKey} className={styles.tabIcon} />API Credentials</span>,
      children: <ApiCredentialsTab />,
    },
  ];

  return (
    <Content className={styles.settingsContent}>
      <div className={styles.settingsHeader}>
        <Text strong className={styles.settingsTitle}>Settings</Text>
        <br />
        <Text type="secondary" className={styles.settingsSubtitle}>
          Manage your account, API credentials, and team members
        </Text>
      </div>
      <Tabs defaultActiveKey="profile" items={tabs} />
    </Content>
  );
};

export default SettingsPage;
